import { OrderTypes } from "../enums";

/** Minimal order shape for eligibility checks (list row, card, or GET response). */
export type EnquiryPaymentLinksOrderLike = {
  _id?: string;
  orderType?: string;
  rootOrderId?: string;
  isDeleted?: boolean;
};

/**
 * Whether ORCA may show / create Zoho payment links on this row:
 * root enquiry (rootOrderId === _id), REGULAR or VIRTUAL, not soft-deleted.
 * Keep in sync with backend `createPaymentLinkForOrder` guards.
 */
export function isEnquiryOrderEligibleForPaymentLinks(
  order: EnquiryPaymentLinksOrderLike | null | undefined,
): boolean {
  if (!order) return false;
  const isSupportedOrderType =
    order.orderType === OrderTypes.REGULAR ||
    order.orderType === OrderTypes.VIRTUAL;
  const isRootEnquiry =
    !!order.rootOrderId &&
    String(order.rootOrderId) === String(order._id);
  return (
    isSupportedOrderType &&
    isRootEnquiry &&
    order.isDeleted !== true
  );
}
